module.exports = __webpack_public_path__ + "media/images/step-1-3fa6d5ae0bc08fd3109b164dadbc9a9e.png";